<template>
    <div>
        <!-- :toPdf="toPdf" -->
        <SingleReportHeader :dataFrom="table.params" @search="searchData" :isRange="true"></SingleReportHeader>
        <Table border :columns="table.columns" :data="table.data" style="margin-top: 12px; margin-bottom: 20px" :max-height="maxHeight" ref="tableRef"></Table>
    </div>
</template>

<script>
import SingleReportHeader from './components/single_report_header.vue'
import { TransTopReq } from '@/api/admin/risk'
import moment from 'moment'
export default {
    name: 'HandicapAppendixData',
    components: { SingleReportHeader },
    data() {
        return {
            maxHeight: 800,
            table: {
                params: {
                    platid: 0,
                    app_id: 0,
                    dataTime: [this.getCurrentZeroDay(), this.getCurrentZeroDay()]
                },
                data: [],
                columns: [
                    { key: 'time', width: 70, align: 'center', renderHeader: (h) => this.renderHeader(h, '日期', '显示日期') },
                    {
                        key: 'new_win_rate',
                        width: 70,
                        resizable: true,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '营收比', '营收金额 / 转入金额'),
                        render: (h, params) => {
                            let val = params.row.new_win_rate
                            let str = '0.00%'
                            if (val === -1) {
                                str = '-'
                            } else if (val) {
                                str = this.calcRateItem(val)
                            }
                            return h('span', str)
                        }
                    },
                    this.renderRateCol('put_pay_rate', '人数转入转出比', '转出人数/转入人数'),
                    this.renderRateCol('pay_winner_rate', '转入赢家数占比', '显示盘口该子游戏的转入赢家数占比'),
                    this.renderRateCol('money_win_rate', '实钱赢家数占比', '【实钱赢家数占比】=【实钱赢家数】/ (【实钱赢家数】+【实钱输家数】)'),
                    this.renderRateCol('new_ci_ri_pay_rate', '新增转入次日复充率', '显示新增转入次日复充率'),
                    this.renderRateCol('ci_ri_pay_rate', '平台转入用户次日复充率', '显示平台转入用户次日复充率'),
                    this.renderRateCol('loss_bet_rate', '游戏盈利率', '游戏盈亏/投注金额'),

                    this.renderCol('pay_sum', '转入', '该日期转入金额', true),
                    this.renderCol('new_win_sum', '营收', '该日期营收金额', true),
                    this.renderCol('pay_user_num', '转入人数', '显示转入人数'),
                    this.renderCol('put_user_num', '提款人数', '显示提款人数'),
                    this.renderCol('vip_pay_num', 'VIP转入人数', '显示VIP转入人数'),
                    this.renderCol('bank_pay_num', '银行卡转入人数', '显示银行卡转入人数'),
                    this.renderRateCol('offline_pay_rate', '线下转入金额占比大盘', '显示线下转入金额占比大盘（转入金额 - 线上转入金额）/ 转入金额'),
                    // {
                    //     key: 'online_pay_all_num',
                    //     minWidth: 70,
                    //     align: 'center',
                    //     renderHeader: (h) => this.renderHeader(h, '线上转入成功率', '显示线上转入成功率'),
                    //     render: (h, params) => {
                    //         let all = params.row.online_pay_all_num;
                    //         let success = params.row.online_pay_success_num;
                    //         let val = all ? success / all : 0;
                    //         return h('span', this.calcRateItem(val));
                    //     },
                    // },
                    this.renderRateCol('zhuan_rate', '新增转化率', '当天新增且转入用户/当天新增人数'),
                    this.renderCol('new_user_num', '新增用户数', '显示新增用户数'),
                    this.renderCol('new_user_pay_num', '新增转入用户数', '显示新增转入用户数'),
                    this.renderCol('new_user_pay_total_sum', '新增转入金额', '显示新增转入金额', true),
                    {
                        key: 'new_user_pay_num',
                        minWidth: 70,
                        align: 'center',
                        render: (h, params) => h('span', this.getCustomFixed(params.row.pay_user_num - params.row.new_user_pay_num)),
                        renderHeader: (h) => this.renderHeader(h, '老用户转入用户数', '显示老用户转入用户数')
                    },
                    {
                        key: 'new_user_pay_total_sum',
                        minWidth: 70,
                        align: 'center',
                        render: (h, params) => h('span', this.getCustomFixed((params.row.pay_sum - params.row.new_user_pay_total_sum) / 10000)),
                        renderHeader: (h) => this.renderHeader(h, '老用户转入金额', '显示老用户转入金额')
                    },
                    this.renderCol('pay_ave', '人均转入金额', '转入金额/转入人数，转入人数不排重', true),
                    this.renderCol('bet_sum', '投注金额', '显示投注金额', true),
                    this.renderCol('game_loss_sum', '游戏盈亏', '显示游戏盈亏', true),
                    this.renderCol('percent_sum', '游戏税收', '显示游戏税收', true),
                    {
                        key: 'bet_pay_rate',
                        minWidth: 70,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '投注转入比', '显示投注转入比'),
                        render: (h, params) => h('span', this.calcRateItem(params.row.bet_pay_rate))
                    },
                    this.renderRateCol('percent_loss_rate', '盈亏税收比', '游戏盈亏/总税收'),
                    this.renderCol('active_user_num', '活跃用户数', '显示活跃用户数'),
                    this.renderCol('bet_user_num', '投注用户数', '显示投注用户数'),
                    this.renderCol('pay_bet_user_num', '转入投注用户数', '显示转入投注用户数'),
                    this.renderCol('agent_num', '历史代理人数', '显示历史代理人数')
                ]
            }
        }
    },
    methods: {
        renderRateCol(key, title, tip) {
            return {
                key,
                width: 80,
                resizable: true,
                align: 'center',
                renderHeader: (h) => this.renderHeader(h, title, tip),
                render: (h, params) => h('span', this.calcRateItem(params.row[key]))
            }
        },
        renderCol(key, title, tip, ispoint = false) {
            return {
                key,
                width: 80,
                resizable: true,
                align: 'center',
                renderHeader: (h) => this.renderHeader(h, title, tip),
                render: (h, params) => h('span', this.getCustomFixed(!ispoint ? params.row[key] : params.row[key] / 10000))
            }
        },
        //查询数据
        searchData() {
            let stime = this.getSecond(this.table.params.dataTime[0])
            let etime = this.getSecond(this.table.params.dataTime[1], false)
            let platid = this.table.params.platid
            let app_id = this.table.params.app_id

            //获取平台数据
            let params = this.getTransTopParams('GetNewPlatfromData', { platid, app_id, stime, etime, general: -1, pack_no: -1, page: 1, limit: 10000, sort: 0 })
            this.TransTopReq(params)
        },
        TransTopReq(params) {
            TransTopReq(params).then((res) => {
                let data = (res._param.data || []).filter((el) => el.time)
                let app_id = params.app_id
                let params1 = this.copyData(params)
                params1.param._func = 'GetUserPayActiveData'

                //获取用户转入行为数据
                TransTopReq(params1).then((res1) => {
                    let userPayData = res1._param.data
                    let params2 = this.copyData(params1)
                    params2.param._func = 'GetNewPlatfromNewPayInfo'

                    //获取新增转入留存数据
                    TransTopReq(params2).then((res2) => {
                        let newPayInfo = res2._param.data || []
                        let params3 = this.copyData(params2)
                        params3.param._func = 'GetNewPlatformRepeatPayInfo'

                        //获取转入留存数据
                        TransTopReq(params3).then((res3) => {
                            let formPayInfo = res3._param.data || []
                            let all = {
                                new_win_sum: 0,
                                bet_user_num: 0,
                                pay_sum: 0,
                                bet_sum: 0,
                                put_num: 0,
                                hit_sum: 0,
                                new_user_pay_num: 0,
                                new_user_num: 0,
                                new_ci_ri_pay_num: 0,
                                ci_ri_all_pay_num: 0,
                                ci_ri_pay_num: 0,
                                game_loss_sum: 0,
                                pay_user_num: 0,
                                put_user_num: 0,
                                vip_pay_num: 0,
                                bank_pay_num: 0,
                                all_pay_sum: 0,
                                down_pay_sum: 0,
                                online_pay_all_num: 0,
                                online_pay_success_num: 0,
                                new_user_pay_total_sum: 0,
                                percent_sum: 0,
                                active_user_num: 0,
                                pay_bet_user_num: 0,
                                agent_num: 0,
                                all_money_user: 0,
                                money_win_user: 0,
                                money_lose_user: 0,
                                pay_winner: 0,
                                loss_bet_rate: 0
                            }
                            all.time = '日均'
                            let count = 0
                            let count1 = 0
                            data.forEach((item) => {
                                item.time = moment(item.time).format('YYYY-MM-DD')
                                item.new_ci_ri_pay_rate = 0
                                item.ci_ri_pay_rate = 0
                                item.offline_pay_rate = 0
                                item.vip_pay_num = 0
                                let find1 = newPayInfo.find((el) => el.time == item.time)

                                if (find1) {
                                    item.new_ci_ri_pay_rate = find1.ci_ri_pay_rate
                                    item.new_ci_ri_pay_num = find1.ci_ri_pay_num || 0
                                }
                                let find2 = formPayInfo.find((el) => el.time == item.time)

                                if (find2) {
                                    item.ci_ri_pay_rate = find2.ci_ri_pay_rate
                                    item.ci_ri_pay_num = find2.ci_ri_pay_num
                                    item.ci_ri_all_pay_num = find2.user_pay_num
                                }
                                let find3 = userPayData.find((el) => el.time == item.time)
                                if (find3) {
                                    item.vip_pay_num = find3.vip_pay_num
                                    item.bank_pay_num = find3.bank_pay_num
                                    item.all_pay_sum = find3.pay_sum
                                    item.down_pay_sum = find3.down_pay_sum
                                    item.offline_pay_rate = this.calcRate(find3.pay_sum - find3.down_pay_sum, find3.pay_sum)
                                }
                                all.new_win_sum += item.new_win_sum || 0
                                all.pay_winner += item.pay_winner || 0
                                all.money_win_user += item.money_win_user || 0
                                all.money_lose_user += item.money_lose_user || 0
                                all.put_user_num += item.put_user_num || 0
                                all.pay_user_num += item.pay_user_num || 0
                                all.vip_pay_num += item.vip_pay_num || 0
                                all.bank_pay_num += item.bank_pay_num || 0
                                all.hit_sum += item.hit_sum || 0
                                all.bet_user_num += item.bet_user_num || 0
                                all.put_num += item.put_num || 0
                                all.bet_sum += item.bet_sum || 0
                                all.all_pay_sum += item.all_pay_sum || 0
                                all.down_pay_sum += item.down_pay_sum || 0
                                all.new_user_pay_num += item.new_user_pay_num || 0
                                all.new_ci_ri_pay_num += item.new_ci_ri_pay_num || 0
                                all.ci_ri_all_pay_num += item.ci_ri_all_pay_num || 0
                                all.ci_ri_pay_num += item.ci_ri_pay_num || 0
                                all.game_loss_sum += item.game_loss_sum || 0
                                all.online_pay_all_num += item.online_pay_all_num || 0
                                all.online_pay_success_num += item.online_pay_success_num || 0
                                all.new_user_num += item.new_user_num || 0
                                all.new_user_pay_total_sum += item.new_user_pay_total_sum || 0
                                all.percent_sum += item.percent_sum || 0
                                all.active_user_num += item.active_user_num || 0
                                all.pay_bet_user_num += item.pay_bet_user_num || 0
                                all.agent_num += item.agent_num || 0
                            })
                            let len = data.length
                            if (len > 0) {
                                all.loss_bet_rate = res._param.loss_bet_rate
                                all.new_win_sum /= len
                                all.pay_sum = res._param.pay_sum / len || 0
                                all.put_user_num /= len
                                all.pay_user_num /= len
                                all.vip_pay_num /= len
                                all.bank_pay_num /= len
                                all.all_moeny_user /= len
                                all.hit_sum /= len
                                all.bet_user_num /= len
                                all.put_num /= len
                                all.bet_sum /= len
                                all.all_pay_sum /= len
                                all.down_pay_sum /= len
                                all.new_user_pay_num /= len
                                all.new_ci_ri_pay_num /= len
                                all.ci_ri_all_pay_num /= len
                                all.ci_ri_pay_num /= len
                                all.game_loss_sum /= len
                                all.online_pay_all_num /= len
                                all.online_pay_success_num /= len
                                all.new_user_num /= len
                                all.new_user_pay_total_sum /= len
                                all.percent_sum /= len
                                all.active_user_num /= len
                                all.pay_bet_user_num /= len
                                all.agent_num /= len
                                all.pay_ave = this.calcRate(all.pay_sum, all.pay_user_num)
                                all.new_win_rate = this.calcRate(all.new_win_sum, all.pay_sum)
                                all.zhuan_rate = this.calcRate(all.new_user_pay_num, all.new_user_num)
                                all.put_pay_rate = this.calcRate(all.put_user_num, all.pay_user_num)
                                all.new_ci_ri_pay_rate = this.calcRate(all.new_ci_ri_pay_num, all.new_user_num)
                                all.ci_ri_pay_rate = this.calcRate(all.ci_ri_pay_num, all.ci_ri_all_pay_num)
                                all.offline_pay_rate = this.calcRate(all.all_pay_sum - all.down_pay_sum, all.all_pay_sum)
                                all.bet_pay_rate = this.calcRate(all.bet_sum, all.pay_sum)
                                all.percent_loss_rate = this.calcRate(all.game_loss_sum, all.percent_sum)
                                all.pay_winner_rate = this.calcRate(all.pay_winner, all.pay_user_num)
                                all.money_win_rate = this.calcRate(all.money_win_user, all.money_win_user + all.money_lose_user)
                            }
                            if (len > 0) {
                                this.table.data = [all, ...data]
                            }
                        })
                    })
                })
            })
        },
        calcRateItem(val) {
            return (val * 100 || 0).toFixed(2) + '%'
        },
        toPdf() {
            this.maxHeight = null
            this.$nextTick(async () => {
                await this.eleToPdf()
                this.maxHeight = 760
            })
        },
        //透传接口请求参数 请求方法 请求参数
        getTransTopParams(func, param) {
            return {
                mod: 'root',
                platid: this.table.params.platid,
                app_id: this.table.params.app_id,
                param: {
                    _mod: 'manager',
                    _func: func,
                    _param: { ...param }
                }
            }
        }
    }
}
</script>

<style scoped lang="less"></style>
